import React from "react";
import "../printStyles.css";

function TyreTorqueCheckForm() {
  return (
    <>
      <style>
        {`
          /* CSS for print functionality */
          @media print {
            /* Hide everything except for the form */
            body * {
              visibility: hidden;
            }

            #TyreTorqueCheckForm, #TyreTorqueCheckForm * {
              visibility: visible;
            }

            /* Make sure the print layout is clean */
            #TyreTorqueCheckForm {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              margin: 0;
              padding: 0;
              box-shadow: none;
              border: none;
            }
            /* Set up page margins for printing */
            @page {
              size: A4;
              margin: 20mm; /* Add a reasonable margin to prevent content from being cut off */
            }

            /* Hide the print button during printing */
            .print-button {
              display: none;
            }
          }
        `}
      </style>
      <div id="TyreTorqueCheckForm" className="p-4 border rounded-lg bg-white shadow-md">
        <h3 className="text-2xl font-semibold mb-4">Tyre & Wheel Torque Check Form</h3>

        <form>
          {/* Vehicle Registration */}
          <div className="mb-4">
            <label className="block text-lg font-medium" htmlFor="vehicleRegistration">
              Vehicle / Trailer Registration:
            </label>
            <input
              type="text"
              id="vehicleRegistration"
              className="p-3 border border-gray-300 rounded-lg w-1/3"
              placeholder="Enter vehicle / trailer registration"
            />
          </div>

          {/* Week Commencing */}
          <div className="mb-4">
            <label className="block text-lg font-medium" htmlFor="weekCommencing">
              Week Commencing:
            </label>
            <input
              type="date"
              id="weekCommencing"
              className="p-3 border border-gray-300 rounded-lg w-1/3"
            />
          </div>

          {/* Checked By */}
          <div className="mb-4">
            <label className="block text-lg font-medium" htmlFor="checkedBy">
              Checked By (Name):
            </label>
            <input
              type="text"
              id="checkedBy"
              className="p-3 border border-gray-300 rounded-lg w-1/3"
              placeholder="Enter name"
            />
          </div>

          {/* Date */}
          <div className="mb-4">
            <label className="block text-lg font-medium" htmlFor="date">
              Date:
            </label>
            <input
              type="date"
              id="date"
              className="p-3 border border-gray-300 rounded-lg w-1/3"
            />
          </div>


          {/* Tyre Condition Check */}
          <div className="mb-6">
            <h4 className="text-xl font-semibold mb-4">Tyre & Torque Check</h4>

            {/* Front Left */}
            <div className="mb-4">
              <h5 className="text-lg font-medium mb-2">Front Left:</h5>
              <div className="flex flex-wrap items-center space-x-4">
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500" />
                  <span className="text-sm">Pressure OK</span>
                </label>
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500" />
                  <span className="text-sm">Tread OK</span>
                </label>
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500" />
                  <span className="text-sm">Damage OK</span>
                </label>
                <input
                  type="text"
                  id="torqueFrontLeft"
                  className="p-2 border border-gray-300 rounded-lg w-38"
                  placeholder="Torque (Nm)"
                />
              </div>
            </div>

            {/* Front Right */}
            <div className="mb-4">
              <h5 className="text-lg font-medium mb-2">Front Right:</h5>
              <div className="flex flex-wrap items-center space-x-4">
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500" />
                  <span className="text-sm">Pressure OK</span>
                </label>
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500" />
                  <span className="text-sm">Tread OK</span>
                </label>
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500" />
                  <span className="text-sm">Damage OK</span>
                </label>
                <input
                  type="text"
                  id="torqueFrontRight"
                  className="p-2 border border-gray-300 rounded-lg w-38"
                  placeholder="Torque (Nm)"
                />
              </div>
            </div>

            {/* Rear Left */}
            <div className="mb-4">
              <h5 className="text-lg font-medium mb-2">Tag / Steer Rear Left:</h5>
              <div className="flex flex-wrap items-center space-x-4">
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500" />
                  <span className="text-sm">Pressure OK</span>
                </label>
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500" />
                  <span className="text-sm">Tread OK</span>
                </label>
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500" />
                  <span className="text-sm">Damage OK</span>
                </label>
                <input
                  type="text"
                  id="torqueRearLeft"
                  className="p-2 border border-gray-300 rounded-lg w-38"
                  placeholder="Torque (Nm)"
                />
              </div>
            </div>

            {/* Rear Right */}
            <div className="mb-4">
              <h5 className="text-lg font-medium mb-2">Tag / Steer Rear Right:</h5>
              <div className="flex flex-wrap items-center space-x-4">
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500" />
                  <span className="text-sm">Pressure OK</span>
                </label>
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500" />
                  <span className="text-sm">Tread OK</span>
                </label>
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500" />
                  <span className="text-sm">Damage OK</span>
                </label>
                <input
                  type="text"
                  id="torqueRearRight"
                  className="p-2 border border-gray-300 rounded-lg w-38"
                  placeholder="Torque (Nm)"
                />
              </div>
            </div>

            {/* Rear Left Outer */}
            <div className="mb-4">
              <h5 className="text-lg font-medium mb-2">Rear Left Outer:</h5>
              <div className="flex flex-wrap items-center space-x-4">
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500" />
                  <span className="text-sm">Pressure OK</span>
                </label>
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500" />
                  <span className="text-sm">Tread OK</span>
                </label>
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500" />
                  <span className="text-sm">Damage OK</span>
                </label>
                <input
                  type="text"
                  id="torqueRearLeftOuter"
                  className="p-2 border border-gray-300 rounded-lg w-38"
                  placeholder="Torque (Nm)"
                />
              </div>
            </div>

            {/* Rear Right Outer */}
            <div className="mb-4">
              <h5 className="text-lg font-medium mb-2">Rear Right Outer:</h5>
              <div className="flex flex-wrap items-center space-x-4">
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500" />
                  <span className="text-sm">Pressure OK</span>
                </label>
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500" />
                  <span className="text-sm">Tread OK</span>
                </label>
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500" />
                  <span className="text-sm">Damage OK</span>
                </label>
                <input
                  type="text"
                  id="torqueRearRightOuter"
                  className="p-2 border border-gray-300 rounded-lg w-38"
                  placeholder="Torque (Nm)"
                />
              </div>
            </div>

            {/* Rear Left Inner */}
            <div className="mb-4">
              <h5 className="text-lg font-medium mb-2">Rear Left Inner:</h5>
              <div className="flex flex-wrap items-center space-x-4">
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500" />
                  <span className="text-sm">Pressure OK</span>
                </label>
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500" />
                  <span className="text-sm">Tread OK</span>
                </label>
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500" />
                  <span className="text-sm">Damage OK</span>
                </label>
                <input
                  type="text"
                  id="torqueRearLeftInner"
                  className="p-2 border border-gray-300 rounded-lg w-38"
                  placeholder="Torque (Nm)"
                />
              </div>
            </div>

            {/* Rear Right Inner */}
            <div className="mb-4">
              <h5 className="text-lg font-medium mb-2">Rear Right Inner:</h5>
              <div className="flex flex-wrap items-center space-x-4">
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500" />
                  <span className="text-sm">Pressure OK</span>
                </label>
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500" />
                  <span className="text-sm">Tread OK</span>
                </label>
                <label className="flex items-center space-x-1">
                  <input type="checkbox" className="form-checkbox text-blue-500" />
                  <span className="text-sm">Damage OK</span>
                </label>
                <input
                  type="text"
                  id="torqueRearRightInner"
                  className="p-2 border border-gray-300 rounded-lg w-38"
                  placeholder="Torque (Nm)"
                />
              </div>
            </div>
          </div>

          {/* Notes Section */}
          <div className="mb-4">
            <label className="block text-lg font-medium" htmlFor="notes">
              Notes:
            </label>
            <textarea
              id="notes"
              className="p-3 border border-gray-300 rounded-lg w-1/3 h-24"
              placeholder="Add any additional notes here..."
            />
          </div>

          {/* Print Button */}
          <div className="mb-4 text-right">
            <button
              type="button"
              onClick={() => window.print()}
              className="w-64 bg-blue-500 text-white p-4 rounded-lg hover:bg-blue-600 transition-colors print-button"
            >
              Print Form
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default TyreTorqueCheckForm;
